import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import store from "@/store/index";

import TemplateNew from "@/views/template/TemplateNew.vue";
import BatchList from "@/views/batch/BatchList.vue";
import BatchNew from "@/views/batch/BatchNew.vue";
import TemplateList from "@/views/template/TemplateList.vue";
import Login from "@/views/session/Login.vue";
import Reset from "@/views/session/Reset.vue";
import RequestList from "@/views/request/RequestList.vue";
import RequestDetail from "@/views/request/RequestDetail.vue";
import UserList from "@/views/user/UserList.vue";
import UserNew from "@/views/user/UserNew.vue";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/sessions/new",
    name: "sessions_new",
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: "/sessions/reset",
    name: "sessions_reset",
    component: Reset,
    meta: {
      guest: true
    }
  },
  {
    path: "/users",
    name: "users",
    component: UserList,
    meta: {
      requiresAdmin: true,
      clearPagination: true
    }
  },
  {
    path: "/users/new",
    name: "users_new",
    component: UserNew,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: "/users/:id",
    name: "users_show",
    component: UserNew,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: "/templates",
    name: "templates",
    component: TemplateList,
    meta: {
      requiresAdmin: true,
      clearPagination: true
    }
  },
  {
    path: "/templates/new",
    name: "templates_new",
    component: TemplateNew,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: "/templates/:id",
    name: "templates_show",
    component: TemplateNew,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: "/batches",
    name: "batches",
    component: BatchList,
    meta: {
      requiresAdmin: true,
      clearPagination: true
    }
  },
  {
    path: "/batches/new",
    name: "batches_new",
    component: BatchNew,
    meta: {
      requiresAdmin: true
    }
  },
  {
    path: "/requests",
    name: "requests",
    component: RequestList,
    meta: {
      requiresAuth: true,
      clearPagination: true
    }
  },
  {
    path: "/requests/:id",
    name: "requests_details",
    component: RequestDetail,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/",
    redirect: to => {
      if (
        store.state.session.user &&
        store.state.session.user.attributes.validated
      ) {
        return "/requests";
      } else {
        return "/sessions/new";
      }
    }
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.clearPagination)) {
    store.commit.CLEAR_PAGINATION();
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.session.token) {
      next({
        path: "/sessions/new",
        params: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresAdmin)) {
    if (
      store.state.session.user &&
      store.state.session.user.attributes.validated &&
      store.state.session.user.attributes.is_admin
    ) {
      next();
    } else {
      next({ path: "/", params: { nextUrl: to.fullPath } });
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!store.state.session.token) {
      next();
    } else {
      next({
        path: "/requests"
      });
    }
  } else {
    next();
  }
});

export default router;
